import React from "react";
import PropTypes from "prop-types";

//components
import ImageDetailHero from "core/ImageDetailHero";
import IconEditor from "icons/IconEditor";
import MoreFromThis from "core/MoreFromThis";
import AboutThisImage from "core/AboutThisImage";
import SimilarIcons from "frontend/components/icons/SimilarIcons";

const IconDetailLayout = ({
    icon,
    heroRightColumnContent,
    moreLikeThisIcon,
    tags,
    createdAt,
    isSuperuser
}) => {
    if (!icon) return null;

    return (
        <>
            <ImageDetailHero
                leftColumnContent={
                    <IconEditor icon={icon} isSuperuser={isSuperuser} />
                }
                rightColumnContent={heroRightColumnContent}
                image={icon}
                imageType="icon"
            />

            <MoreFromThis
                items={moreLikeThisIcon.items}
                heading={moreLikeThisIcon.heading}
                viewAllLink={moreLikeThisIcon.viewAll}
                eachDataTestId="more-from-icon-collection"
                useRouterLink
            />

            <AboutThisImage
                sectionHeading="About this icon"
                sectionDataTestId="icon-detail-about"
                image={icon}
                tags={tags}
                createdAt={createdAt}
                isIcons
            />

            <SimilarIcons slugWithId={icon.slugWithId} />
        </>
    );
};

IconDetailLayout.propTypes = {
    icon: PropTypes.object.isRequired,
    heroRightColumnContent: PropTypes.element.isRequired,
    moreLikeThisIcon: PropTypes.object,
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
            url: PropTypes.string
        })
    ),
    createdAt: PropTypes.string,
    isSuperuser: PropTypes.bool.isRequired
};

export default IconDetailLayout;
